import { baseUrl } from '../../config/appsettings';

const PaymentApiService = {
  /**
   * Get all user payment methods
   */
  Get: async () => {
    try {
      const response = await fetch(`${baseUrl}Payment/Get`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Get Payment Methods Error:', error);
      throw new Error('Network error');
    }
  },

  GetByPublisher: async (publisherId) => {
    try {
      const response = await fetch(`${baseUrl}Payment/GetByPublisher/${publisherId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Get Payment Methods Error:', error);
      throw new Error('Network error');
    }
  },

  SetActive: async (id) => {
    try {
      const response = await fetch(`${baseUrl}Payment/SetActive/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Get Payment Methods Error:', error);
      throw new Error('Network error');
    }
  },

  /**
   * Add new payment method
   * @param {Object} data - Payment method object
   */
  Add: async (data) => {
    try {
      const response = await fetch(`${baseUrl}Payment/Create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Add Payment Method Error:', error);
      throw new Error('Network error');
    }
  },

  /**
   * Update existing payment method
   * @param {Object} data - Payment method object
   */
  Update: async (data) => {
    try {
      const response = await fetch(`${baseUrl}Payment/Update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Update Payment Method Error:', error);
      throw new Error('Network error');
    }
  },

  /**
   * Delete payment method by ID
   * @param {number} id - Payment method ID
   */
  Delete: async (id) => {
    try {
      const response = await fetch(`${baseUrl}Payment/Delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Delete Payment Method Error:', error);
      throw new Error('Network error');
    }
  },

  /**
   * Add payment info (simplified variant if required)
   * @param {Object} data - Basic payment info
   */
  AddPaymentInformation: async (data) => {
    try {
      const response = await fetch(`${baseUrl}Payment/AddPaymentInfo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      return response.ok ? result : Promise.reject(result);
    } catch (error) {
      console.error('Add Payment Info Error:', error);
      throw new Error('Network error');
    }
  },
};

export default PaymentApiService;
